import React, { useContext } from "react";
import { DispatchContext, StateContext } from "bodycodi/cmap/app/components/common/context";
import CustomDialog from "bodycodi/cmap/app/components/common/customDialog";
import PopupHeader from "bodycodi/cmap/app/components/common/popupHeader";
import ClassMemberList from "bodycodi/cmap/app/components/cmap2020/ClassMemberList";

interface ViewAllRsrvMember {
  isSeatClass: boolean;
  RsrvMemberList: any;
  reservationLimitNo: number;
  clickedMembers: any;
  handleClickMember: any;
  openClassScheduleBtn: any;
}

const ViewAllRsrvMember = ({
  isSeatClass,
  RsrvMemberList,
  reservationLimitNo,
  clickedMembers,
  handleClickMember,
  openClassScheduleBtn,
}: ViewAllRsrvMember) => {
  const { state } = useContext(StateContext);
  const { dispatch } = useContext(DispatchContext);

  const handleClose = () => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "VIEW_ALL_RSRV_MEMBER_POP",
      open: { viewAllRsrvMemberPop: false },
    });
  };

  return (
    <CustomDialog open={state.viewAllRsrvMemberPop} onClose={handleClose}>
      <PopupHeader title="현황 전체보기" onClickBack={handleClose} closeBtn={true} />
      {state.viewAllRsrvMemberPop && (
        <>
          <div className="popup-body no-padding">
            <div className="allmember-wrapper">
              <ClassMemberList
                isWatingMember={false}
                isLimit={false}
                isSeatClass={isSeatClass}
                reservationLimitNo={reservationLimitNo}
                classMemberList={RsrvMemberList}
                clickedMembers={clickedMembers}
                onClickMember={handleClickMember}
              />
            </div>
          </div>
          {clickedMembers.length === 0 ? (
            <div className="schedule-pop-btn-disable">출결 처리할 회원을 선택해주세요!</div>
          ) : (
            <div className="schedule-pop-btn class" onClick={openClassScheduleBtn}>
              출결 처리하기
            </div>
          )}
        </>
      )}
    </CustomDialog>
  );
};

export default ViewAllRsrvMember;
